'use client';

import { useEffect } from 'react';

import { safeCall } from '@/app/utils/safeCall';

interface UseEscapeKeyProps {
  enabled?: boolean;
  onClose?: () => void;
}

export const useEscapeKey = ({
  enabled = true,
  onClose,
}: UseEscapeKeyProps) => {
  useEffect(() => {
    if (!enabled) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key !== 'Escape') return;

      event.preventDefault(); // Avoid browser fullscreen exit (Safari)
      event.stopPropagation(); // Avoid bubbling to nested overlays
      safeCall(onClose);
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [enabled, onClose]);
};
